import { ApplicationConfig, ErrorHandler, importProvidersFrom, Injectable } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from "@angular/common/http";

import * as Sentry from "@sentry/angular-ivy";
import { routes } from './app.routes';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from "@angular/platform-browser";
import * as Hammer from 'hammerjs';
import { provideAnimations } from "@angular/platform-browser/animations";
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { environment } from "../environments/environment";

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  override overrides = <any>{
    swipe: { direction: Hammer.DIRECTION_HORIZONTAL },
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(routes),
    provideHttpClient(),
    importProvidersFrom(HammerModule),
    importProvidersFrom(RecaptchaV3Module),
    { provide: 'Storage', useValue: localStorage },
    { provide: 'Window', useValue: window },
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },
    { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha }
  ]
};

